// shadcn/ui input (CLI 4.21.0), rebound to docs/tokens.css: the control
// radius and height, a hairline input border on the card colour, a blue
// border and halo on focus. Inside a <Toolbar> it drops to the table-tool
// height on its own.
import * as React from "react";
import { cn } from "@/lib/utils";

// forwardRef: React 18 (see button.tsx).
const Input = React.forwardRef<HTMLInputElement, React.ComponentPropsWithoutRef<"input">>(function Input(
  { className, type, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        "h-control w-full min-w-0 rounded-control border border-input bg-card px-3 text-body text-foreground outline-none transition-[border-color,box-shadow] placeholder:text-muted-foreground dark:bg-muted",
        "file:mr-3 file:h-full file:border-0 file:bg-transparent file:font-medium file:text-ink",
        "focus-visible:border-primary focus-visible:outline-focus disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-70",
        "aria-invalid:border-destructive",
        type === "file" && "py-1",
        className,
      )}
      {...props}
    />
  );
});

export { Input };
